/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Distributor,
    DistributorFromJSON,
    DistributorFromJSONTyped,
    DistributorToJSON,
} from './Distributor';

/**
 * GET /distributors/{id}
 * @export
 * @interface GetDistributorDetailSuccessResponse
 */
export interface GetDistributorDetailSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetDistributorDetailSuccessResponse
     */
    status: number;
    /**
     * エラーメッセージ。原則英語。
     * @type {string}
     * @memberof GetDistributorDetailSuccessResponse
     */
    message: string;
    /**
     * 
     * @type {Distributor}
     * @memberof GetDistributorDetailSuccessResponse
     */
    data: Distributor;
}

export function GetDistributorDetailSuccessResponseFromJSON(json: any): GetDistributorDetailSuccessResponse {
    return GetDistributorDetailSuccessResponseFromJSONTyped(json, false);
}

export function GetDistributorDetailSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDistributorDetailSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': DistributorFromJSON(json['data']),
    };
}

export function GetDistributorDetailSuccessResponseToJSON(value?: GetDistributorDetailSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': DistributorToJSON(value.data),
    };
}

